import { render } from "./m-card-result.vue?vue&type=template&id=0ecdc017&scoped=true&ts=true"
import script from "./m-card-result.vue?vue&type=script&lang=ts"
export * from "./m-card-result.vue?vue&type=script&lang=ts"

import "./m-card-result.vue?vue&type=style&index=0&id=0ecdc017&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecdc017"]])

export default __exports__